// https://openlayers.org/en/latest/examples/draw-shapes.html
// https://openlayers.org/en/latest/examples/draw-and-modify-features.html
import ol from 'openlayers';

export function drawBoxInteraction(source: ol.source.Vector) { return new ol.interaction.Draw({ source: source, type: 'Circle', geometryFunction: ol.interaction.Draw.createRegularPolygon(4) }); }

export function drawRectangleInteraction(source: ol.source.Vector, styleFunction: any) { return new ol.interaction.Draw({ style: styleFunction, source: source, type: 'Circle', geometryFunction: ol.interaction.Draw.createBox() }); }


export function drawStarInteraction(source: ol.source.Vector) {
    return new ol.interaction.Draw({
        source: source, type: 'Circle',
        geometryFunction: (coordinates: any, geometry: any) => {
            var center = coordinates[0];
            var last = coordinates[1];
            var dx = center[0] - last[0];
            var dy = center[1] - last[1];
            var radius = Math.sqrt(dx * dx + dy * dy);
            var rotation = Math.atan2(dy, dx);
            var newCoordinates: [number, number][] = [];
            var numPoints = 12;
            for (var i = 0; i < numPoints; ++i) {
                var angle = rotation + i * 2 * Math.PI / numPoints;
                var fraction = i % 2 === 0 ? 1 : 0.5;
                var offsetX = radius * fraction * Math.cos(angle);
                var offsetY = radius * fraction * Math.sin(angle);
                newCoordinates.push([center[0] + offsetX, center[1] + offsetY]);
            }
            newCoordinates.push(<any>newCoordinates[0].slice());
            if (geometry === undefined) {
                geometry = new ol.geom.Polygon([newCoordinates]);
            } else {
                geometry.setCoordinates([newCoordinates]);
            }
            return geometry;
        }
    });
}

export function drawPolygonInteraction(source: ol.source.Vector, styleFunction: any) { return new ol.interaction.Draw({ style: styleFunction, source: source, type: 'Polygon' }); }

export function removedrawInteractions() { };




// export function computeAreaFromCoordinates(coordinates: [number, number][]) {
//     var arrayOfx = coordinates.map(c => c[0]), arrayOfy = coordinates.map(c => c[1]);

//     let n = arrayOfx.length - 1;

//     let j = n - 1;

//     let area = 0;
//     for (var i = 0; i < n; i++) {
//         area += (arrayOfx[j] + arrayOfx[i]) * (arrayOfy[j] - arrayOfy[i]);
//         j = i;
//     }
// console.log(area);
//     return Math.abs(area / 2);
// }
